var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pay-info-container" },
    [
      _c(
        "el-card",
        {
          scopedSlots: _vm._u([
            {
              key: "header",
              fn: function() {
                return [_c("TitleItem", { attrs: { title: "支付信息" } })]
              },
              proxy: true
            }
          ])
        },
        [
          _c(
            "el-form",
            {
              ref: "payInfoForm",
              attrs: { model: _vm.payInfoModel, "label-width": "125px" }
            },
            [
              _vm.isSetWxFee == 1
                ? _c(
                    "el-form-item",
                    { attrs: { label: "微信支付" } },
                    [
                      _c(
                        "el-checkbox",
                        {
                          attrs: { "true-label": 1, "false-label": 0 },
                          model: {
                            value: _vm.payInfoModel.isAssumeWxFee,
                            callback: function($$v) {
                              _vm.$set(_vm.payInfoModel, "isAssumeWxFee", $$v)
                            },
                            expression: "payInfoModel.isAssumeWxFee"
                          }
                        },
                        [_vm._v("启用")]
                      ),
                      [
                        _c("span", { staticClass: "weChatTipsNormal" }, [
                          _vm._v("(商家需承担0.63%的手续费)")
                        ])
                      ]
                    ],
                    2
                  )
                : _vm._e(),
              _vm.is_alipay == 1
                ? _c(
                    "el-form-item",
                    { attrs: { label: "支付宝支付" } },
                    [
                      _c(
                        "el-checkbox",
                        {
                          attrs: { "true-label": 1, "false-label": 0 },
                          model: {
                            value: _vm.payInfoModel.isAssumeAlipayFee,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.payInfoModel,
                                "isAssumeAlipayFee",
                                $$v
                              )
                            },
                            expression: "payInfoModel.isAssumeAlipayFee"
                          }
                        },
                        [_vm._v("启用")]
                      ),
                      _c("span", { staticClass: "weChatTipsNormal" }, [
                        _vm._v("(商家需承担0.6%的手续费(活动期费率))")
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _vm.is_fast_payment == 1
                ? _c(
                    "el-form-item",
                    { attrs: { label: "银行卡支付" } },
                    [
                      _c(
                        "el-checkbox",
                        {
                          attrs: { "true-label": 1, "false-label": 0 },
                          model: {
                            value: _vm.payInfoModel.isAssumeCloudFee,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.payInfoModel,
                                "isAssumeCloudFee",
                                $$v
                              )
                            },
                            expression: "payInfoModel.isAssumeCloudFee"
                          }
                        },
                        [_vm._v("启用")]
                      ),
                      _c("span", { staticClass: "weChatTipsNormal" }, [
                        _vm._v("(商家需承担手续费：储蓄卡:0.3%,信用卡:0.6%)")
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _vm.is_multiply_pay == 1
                ? _c(
                    "el-form-item",
                    { attrs: { label: "多次支付" } },
                    [
                      _c(
                        "el-checkbox",
                        {
                          attrs: { "true-label": 1, "false-label": 0 },
                          model: {
                            value: _vm.payInfoModel.isMultiplyPay,
                            callback: function($$v) {
                              _vm.$set(_vm.payInfoModel, "isMultiplyPay", $$v)
                            },
                            expression: "payInfoModel.isMultiplyPay"
                          }
                        },
                        [_vm._v("启用")]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.is_receipt_confirmation == 1
                ? _c(
                    "el-form-item",
                    { attrs: { label: "收货确认" } },
                    [
                      _c(
                        "el-checkbox",
                        {
                          attrs: { "true-label": 1, "false-label": 0 },
                          model: {
                            value: _vm.payInfoModel.isReceiptConfirmation,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.payInfoModel,
                                "isReceiptConfirmation",
                                $$v
                              )
                            },
                            expression: "payInfoModel.isReceiptConfirmation"
                          }
                        },
                        [_vm._v("启用")]
                      ),
                      _c("span", { staticClass: "weChatTipsNormal" }, [
                        _vm._v("(启用后，卖家可以确认订单最终收货数量)")
                      ])
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }